import React from "react";

import {FIELD_TYPE} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
import dayjs from "dayjs";
import {ColumnProps} from "../../../../../types/models";

const {COMBO_BOX} = FIELD_TYPE;

const listMonths = [];
for (let month = 1; month <= 12; month++) {
  listMonths.push({
    value: month,
    label: `Tháng ${month}`,
  });
}

//--------------------------------------------------------
const listYears = [];
const currentYear = new Date().getFullYear();
const startYear = 2020;
const endYear = currentYear + 100;
for (let year = startYear; year <= endYear; year++) {
  listYears.push({
    value: year,
    label: year.toString(),
  });
}

const convertPersonStatus = (status: number) => {
  return status === 1 ? "Còn sử dụng" : "Không còn sử dụng";
};

const allColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    disabledCheck: true,
    // fixed: "left",
    width: 40,
    align: "center",
    isResizable: true,
  },
  {
    title: "Mã quyền duyệt",
    key: "id_quyen_duyet",
    show: true,
    dataIndex: "id_quyen_duyet",
    width: 150,
    align: "center",
    //  fixed: "left",
    isResizable: true,
  },
  {
    title: "Role",
    key: "role",
    show: true,
    dataIndex: "role",
    width: 150,
    align: "center",
    //  fixed: "left",
    isResizable: true,
  },
  {
    title: "Ghi chú",
    key: "ghi_chu",
    show: true,
    isResizable: true,
    dataIndex: "ghi_chu",
    width: 90,
    align: "center",
  },
  {
    title: "Ngày hiệu lực từ",
    key: "ngay_hieu_luc",
    show: true,
    isResizable: true,
    dataIndex: "ngay_hieu_luc",
    width: 60,
    align: "center",
    render: (v, r, idx) => (v !== null ? dayjs(v).format("DD/MM/YYYY") : null),
  },
  {
    title: "Ngày hiệu lực đến",
    key: "ngay_het_hieu_luc",
    show: true,
    isResizable: true,
    dataIndex: "ngay_het_hieu_luc",
    width: 60,
    align: "center",
    render: (v, r, idx) => (v !== null ? dayjs(v).format("DD/MM/YYYY") : null),
  },
  {
    title: "Trạng thái",
    key: "trang_thai",
    show: true,
    isResizable: true,
    dataIndex: "trang_thai",
    width: 60,
    align: "center",
    render: (v, r, idx) => convertPersonStatus(v),
  },
  {
    title: "Tác vụ",
    dataIndex: "action",
    show: true,
    align: "center",
    fixed: "right",
    width: 60,
    key: "action",
  },
];

const itemsInputField: DataFormField[] = [
  {
    type: COMBO_BOX,
    label: "Người sử dụng",
    name: "nguoiSuDung",
    disable: false,
  },
];

export {allColumns, itemsInputField};
